import {object, string, array} from "yup";

export default ({isLocalRecEvent, intl}) => {
    return isLocalRecEvent ?
        object()
            .shape({
                userEmails: array().of(
                    object().shape({ email: string().email().required(intl.formatMessage({id: "app.form.required"})) })
                ).min(1, intl.formatMessage({id: "app.form.required"})),
            }) :
        object().nullable();
};
